module.exports = __webpack_public_path__ + "static/media/gravidanza.3c1ae2fc.svg";